import { render, staticRenderFns } from "./ConfigurationList.html?vue&type=template&id=3bbd46f0&scoped=true&"
import script from "./ConfigurationList.vue?vue&type=script&lang=js&"
export * from "./ConfigurationList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationList.vue?vue&type=style&index=0&id=3bbd46f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd46f0",
  null
  
)

export default component.exports